export default __webpack_public_path__ + "static/media/304.f1ee7a4e.jpg";